import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=4a94ed77&scoped=true&"
import script from "./AttachmentList.vue?vue&type=script&lang=js&"
export * from "./AttachmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94ed77",
  null
  
)

export default component.exports